import type {
  UserOTCPayOrderInput,
  UserOTCPlaceOrderInput,
  UserOTCFinalizeConvertOrderInput,
  UserOTCPlaceConvertOrderInput,
  UserGetOtcPriceParams,
  UserOtcGetHistoryParams,
} from '../api'
import { api } from '../api'

const otcPayOrder = async (data: UserOTCPayOrderInput) => {
  return await api.v1.userOtcPayOrder({
    ...data,
  })
}

const otcPlaceOrder = async (data: UserOTCPlaceOrderInput) => {
  return await api.v1.userOtcPlaceOrder({
    ...data,
  })
}

const getOtcPrice = async (data: UserGetOtcPriceParams) => {
  return await api.v1.userGetOtcPrice({
    ...data,
  })
}

const otcGetHistory = async (data: UserOtcGetHistoryParams) => {
  return await api.v1.userOtcGetHistory({
    ...data,
  })
}

const otcPlaceConvertOrder = async (data: UserOTCPlaceConvertOrderInput) => {
  return await api.v1.userOtcPlaceConvertOrder({
    ...data,
  })
}

const otcFinalizeConvertOrder = async (
  data: UserOTCFinalizeConvertOrderInput,
) => {
  return await api.v1.userOtcFinalizeConvertOrder({
    ...data,
  })
}

export default {
  otcPayOrder,
  otcPlaceOrder,
  getOtcPrice,
  otcGetHistory,
  otcPlaceConvertOrder,
  otcFinalizeConvertOrder,
}
